var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-container" }, [
    _c(
      "div",
      { staticClass: "header_nav w", class: !_vm.isLogin ? "unLogin" : "" },
      [
        _c("router-link", { staticClass: "nav_logo", attrs: { to: "/" } }, [
          _c("img", {
            staticClass: "pointer logo-img",
            attrs: { src: _vm.config.logo, alt: _vm.config.site_title }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "logo-divider" }),
          _vm._v(" "),
          _c("span", { staticClass: "logo-sub" }, [_vm._v("一手资源供应商")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nav_right" }, [
          _c("div", { staticClass: "nav_group" }, [
            _c(
              "div",
              { staticClass: "nav-group-left" },
              [
                _vm.profile.is_new !== 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        attrs: {
                          exact: "",
                          "active-class": "nav-active",
                          to: "/"
                        }
                      },
                      [_vm._v("后台首页\n            ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.profile.is_new !== 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        attrs: {
                          "active-class": "nav-active",
                          to: "/index/hotmedia"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "nav-hot",
                          attrs: {
                            src:
                              "https://newsosssts.oss-cn-shanghai.aliyuncs.com/avatar/190/cfecdb276f634854f3ef915e2e980c31.png",
                            alt: ""
                          }
                        }),
                        _vm._v("\n              优选GEO\n            ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.profile.is_new !== 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        attrs: {
                          "active-class": "nav-active",
                          to: "/index/article"
                        }
                      },
                      [_vm._v("软文价格\n            ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.profile.is_new !== 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        attrs: {
                          "active-class": "nav-active",
                          to: "/index/zimeiti"
                        }
                      },
                      [_vm._v("自媒体推广\n            ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.profile.is_new !== 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        attrs: {
                          "active-class": "nav-active",
                          to: "/index/video"
                        }
                      },
                      [_vm._v("短视频价格\n            ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.profile.is_new !== 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        class: { "nav-active": _vm.isPublishRoute },
                        attrs: {
                          "active-class": "nav-active",
                          to: "/index/create"
                        }
                      },
                      [_vm._v("文章发布\n            ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.profile.recharge === 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        attrs: {
                          "active-class": "nav-active",
                          to: "/recharge_center"
                        }
                      },
                      [_vm._v("我要充值\n            ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "head_top_right" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("span", { staticClass: "header-split" }),
            _vm._v(" "),
            _c(
              "el-popover",
              {
                attrs: {
                  placement: "bottom-end",
                  width: "274",
                  trigger: "hover"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "user",
                    attrs: { slot: "reference" },
                    slot: "reference"
                  },
                  [
                    _c("img", {
                      staticClass: "header-avatar",
                      attrs: { src: _vm.profile.avatar, alt: "" }
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.profile.name
                            ? _vm.profile.name
                            : _vm.profile.mobile
                        ) +
                        "\n            "
                    ),
                    _c("i", {
                      staticClass: "el-icon-caret-bottom",
                      staticStyle: {
                        "font-size": "14px",
                        "padding-left": "4px"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "user-popover" }, [
                  _c("div", { staticClass: "user-popover-links" }, [
                    _c(
                      "a",
                      {
                        staticClass: "user-popover-link-item",
                        attrs: { href: "/own/finance/invoice_list" }
                      },
                      [
                        _c("svg-icon", {
                          staticStyle: {
                            width: "14px",
                            height: "12px",
                            "margin-right": "8px"
                          },
                          attrs: {
                            "icon-class":
                              "https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover04.svg"
                          }
                        }),
                        _vm._v("\n                发票中心\n                "),
                        _c("div", { staticClass: "flex-spacer" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "el-icon-arrow-right" })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "user-popover-link-item",
                        attrs: { href: "/own/personal/profile" }
                      },
                      [
                        _c("svg-icon", {
                          staticStyle: {
                            width: "14px",
                            height: "12px",
                            "margin-right": "8px"
                          },
                          attrs: {
                            "icon-class":
                              "https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover04.svg"
                          }
                        }),
                        _vm._v("\n                资料编辑\n                "),
                        _c("div", { staticClass: "flex-spacer" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "el-icon-arrow-right" })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "user-popover-link-item",
                        attrs: { href: "/own/personal/password" }
                      },
                      [
                        _c("svg-icon", {
                          staticStyle: {
                            width: "14px",
                            height: "12px",
                            "margin-right": "8px"
                          },
                          attrs: {
                            "icon-class":
                              "https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover04.svg"
                          }
                        }),
                        _vm._v("\n                修改密码\n                "),
                        _c("div", { staticClass: "flex-spacer" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "el-icon-arrow-right" })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "logout" }, [
                    _c(
                      "a",
                      { staticClass: "pointer", on: { click: _vm.onLogout } },
                      [_vm._v("退出登录")]
                    )
                  ])
                ])
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-slogan" }, [
      _c("img", {
        attrs: { src: require("../../assets/home/icon-bell.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("一手资源")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc92a38e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc92a38e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Header.vue
// module id = null
// module chunks = 